"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FieldRow = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _formik = require("formik");

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _constant = require("../constant");

var _GuestPersonalInfo = require("../GuestPersonalInfo");

var _constant2 = require("./constant");

var _GuestPassportInfo = _interopRequireDefault(require("./GuestPassportInfo.proptypes"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "GuestPassportInfo__StyledContainer",
  componentId: "sc-1u4bm7i-0"
})([""]);

var FieldRow = _styledComponents.default.div.withConfig({
  displayName: "GuestPassportInfo__FieldRow",
  componentId: "sc-1u4bm7i-1"
})(["width:100%;position:", ";display:", ";"], function (_ref) {
  var isMobile = _ref.isMobile;
  return !isMobile ? 'relation' : '';
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return !isMobile ? 'flex' : '';
}); // eslint-disable-next-line no-unused-vars


exports.FieldRow = FieldRow;

var validateExpiryDate = function validateExpiryDate(value, field, translation, isMobile, flightDate, isPassportMandatory, isExpiryDateMandatory) {
  var error = _GuestPersonalInfo.validate.date(value, field, translation, isMobile, '', flightDate, false, {}, isExpiryDateMandatory, false);

  if (!isExpiryDateMandatory) {
    return error;
  }

  return error;
};

var GuestPassportInfo = function GuestPassportInfo(_ref3) {
  var accessible = _ref3.accessible,
      theme = _ref3.theme,
      customProperties = _ref3.customProperties,
      initialValues = _ref3.initialValues,
      onSubmit = _ref3.onSubmit,
      formRef = _ref3.formRef,
      translation = _ref3.translation,
      handleField = _ref3.handleField,
      fireGtm = _ref3.fireGtm,
      gtmParameters = _ref3.gtmParameters,
      gtmLabel = _ref3.gtmLabel,
      flightDate = _ref3.flightDate,
      isWMP = _ref3.isWMP,
      isPassportMandatory = _ref3.isPassportMandatory,
      isDropdown = _ref3.isDropdown,
      isExpiryDateMandatory = _ref3.isExpiryDateMandatory,
      disableDocumentNumber = _ref3.disableDocumentNumber,
      disableExpiryDate = _ref3.disableExpiryDate,
      documentTypes = _ref3.documentTypes,
      disableDropdown = _ref3.disableDropdown;

  var innerWidth = function innerWidth() {
    return typeof window !== 'undefined' ? window.innerWidth : 300;
  };

  var _React$useState = _react.default.useState(innerWidth()),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      windowWidth = _React$useState2[0],
      setWindowWidth = _React$useState2[1];

  var gtmParams = gtmParameters && JSON.parse(gtmParameters);

  var _React$useState3 = _react.default.useState([]),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      errorList = _React$useState4[0],
      setErrorList = _React$useState4[1];

  var _React$useState5 = _react.default.useState([_GuestPersonalInfo.validate.required, _GuestPersonalInfo.validate.alphanumericspace, _GuestPersonalInfo.validate.maxLen]),
      _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
      fieldValidation = _React$useState6[0],
      setFieldValidation = _React$useState6[1];

  var _ref4 = gtmParams || {},
      eventLabelView = _ref4.eventLabelView,
      appName = _ref4.appName;

  _react.default.useEffect(function () {
    if (errorList.length > 0) {
      (0, _GuestPersonalInfo.createErrorGtmObject)(errorList, gtmLabel, fireGtm, appName);
    }
  }, [appName, errorList, fireGtm, gtmLabel]);

  var errorCallback = function errorCallback(field, add) {
    if (add) {
      var newList = errorList.filter(function (val) {
        return val === field;
      });

      if (newList.length <= 0) {
        setErrorList([].concat((0, _toConsumableArray2.default)(errorList), [field]));
      }
    } else {
      var _newList = errorList.filter(function (val) {
        return val !== field;
      });

      setErrorList((0, _toConsumableArray2.default)(_newList));
    }
  };
  /* istanbul ignore next */


  _react.default.useEffect(function () {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', function () {
        return setWindowWidth(innerWidth());
      });
    }

    return function () {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', function () {
          return setWindowWidth(innerWidth());
        });
      }
    };
  }, []);

  _react.default.useEffect(function () {
    if (isPassportMandatory) {
      setFieldValidation([_GuestPersonalInfo.validate.required, _GuestPersonalInfo.validate.alphanumericspace, _GuestPersonalInfo.validate.maxLen]);
    } else {
      setFieldValidation([_GuestPersonalInfo.validate.alphanumericspace, _GuestPersonalInfo.validate.maxLen]);
    }
  }, [isPassportMandatory]);

  _react.default.useEffect(function () {
    if (formRef) {
      formRef.current.setValues(initialValues);
      formRef.current.validateForm(initialValues);
    } // eslint-disable-next-line  react-hooks/exhaustive-deps

  }, [initialValues]);

  var isMobile = windowWidth <= parseInt(_constant.BREAKPOINTS.MOBILE.replace('px', ''), 10);

  var language = _objectSpread(_objectSpread({}, _constant2.TRANSLATION), translation);

  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(StyledContainer, (0, _extends2.default)({}, customProperties, {
    tabIndex: !accessible ? '-1' : '0'
  }), /*#__PURE__*/_react.default.createElement(_formik.Formik, (0, _extends2.default)({
    innerRef: formRef,
    initialValues: {},
    onSubmit: onSubmit
  }, customProperties, {
    validateOnChange: false,
    enableReinitialize: true
  }), function (props) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
      _react.default.createElement("form", {
        onSubmit: props.handleSubmit,
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter') {
            props.handleSubmit();
          }
        }
      }, /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
        isMobile: isMobile,
        title: true
      }, /*#__PURE__*/_react.default.createElement(_Text.default, {
        accessible: false,
        bold: true,
        display: "block",
        theme: "AIRASIA_CLASSIC",
        type: "sub"
      }, isDropdown ? language.type : language.passportDetails)), /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.Container, null, isDropdown ? /*#__PURE__*/_react.default.createElement(FieldRow, {
        isMobile: isMobile
      }, /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
        width: isMobile
      }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: _GuestPersonalInfo.renderSelect,
        accessible: accessible,
        alwaysShowLabel: false,
        label: language.type || _constant2.FIELDS.type.label,
        name: _constant2.FIELDS.type.name,
        theme: theme,
        items: documentTypes,
        handleField: handleField,
        value: props.values[_constant2.FIELDS.type.name],
        validate: function validate(val) {
          return _GuestPersonalInfo.validate.required(val, language.type || _constant2.FIELDS.type.label, language);
        },
        isMobile: isMobile,
        gtmAction: fireGtm,
        createGtmObject: _GuestPersonalInfo.createGtmObject,
        gtmParams: gtmParams,
        gtmLabel: gtmLabel,
        errorCallback: errorCallback,
        withLabelOpacity: true,
        touched: props.touched[_constant2.FIELDS.type.name],
        disableDropdown: disableDropdown
      })), /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
        width: isMobile
      }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: _GuestPersonalInfo.renderField,
        accessible: accessible,
        alwaysShowLabel: false,
        label: props.values[_constant2.FIELDS.type.name] === _constant2.DEFAULT_DOC_TYPE.value ? language.passportNumber : language.docNumber,
        name: _constant2.FIELDS.docNumber.name,
        theme: theme,
        handleField: handleField,
        gtmParameters: eventLabelView,
        gtmAction: fireGtm,
        createGtmObject: _GuestPersonalInfo.createGtmObject,
        errorCallback: errorCallback,
        gtmParams: gtmParams,
        gtmLabel: gtmLabel,
        value: props.values[_constant2.FIELDS.type.name] === _constant2.DEFAULT_DOC_TYPE.value && props.values[_constant2.FIELDS.passportNumber.name] && props.values[_constant2.FIELDS.passportNumber.name] !== '' ? props.values[_constant2.FIELDS.passportNumber.name] : props.values[_constant2.FIELDS.docNumber.name],
        validate: function validate(val) {
          return (0, _GuestPersonalInfo.validators)(val, language.docNumber || _constant2.FIELDS.docNumber.label, language, fieldValidation);
        },
        touched: props.touched[_constant2.FIELDS.docNumber.name],
        isRequired: isPassportMandatory,
        disabled: disableDocumentNumber,
        triggerOnChange: true
      })), props.values[_constant2.FIELDS.type.name] === _constant2.DEFAULT_DOC_TYPE.value && /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
        width: isMobile
      }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: _GuestPersonalInfo.renderDate,
        accessible: accessible,
        alwaysShowLabel: false // label={language.expiryDate || FIELDS.expiryDate.label}
        ,
        label: // eslint-disable-next-line max-len
        (isPassportMandatory || isExpiryDateMandatory ? String(language.expiryDate).split('(')[0].trim() : language.expiryDate) || _constant2.FIELDS.expiryDate.label,
        name: _constant2.FIELDS.expiryDate.name,
        theme: theme,
        handleField: handleField,
        gtmParameters: eventLabelView,
        gtmAction: fireGtm,
        createGtmObject: _GuestPersonalInfo.createGtmObject,
        errorCallback: errorCallback,
        gtmParams: gtmParams,
        gtmLabel: gtmLabel,
        value: props.values[_constant2.FIELDS.expiryDate.name],
        validate: function validate(val) {
          return _GuestPersonalInfo.validate.date(val, language.expiryDate || _constant2.FIELDS.expiryDate.label, language, isMobile, '', flightDate, false, {}, true, (isPassportMandatory || isExpiryDateMandatory) && props.values[_constant2.FIELDS.type.name] === _constant2.DEFAULT_DOC_TYPE.value, false);
        },
        isMobile: isMobile && !isWMP // isRequired={props.values[FIELDS.expiryDate.name] !== ''}
        ,
        isRequired: isPassportMandatory || props.values[_constant2.FIELDS.expiryDate.name] !== '',
        placeholder: language.dateFormat,
        touched: props.touched[_constant2.FIELDS.expiryDate.name],
        disabled: disableExpiryDate,
        triggerOnChange: true
      }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
        width: isMobile ? 100 : 50
      }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: _GuestPersonalInfo.renderField,
        accessible: accessible,
        alwaysShowLabel: false,
        label: language.passportNumber || _constant2.FIELDS.passportNumber.label,
        name: _constant2.FIELDS.passportNumber.name,
        theme: theme,
        handleField: handleField,
        gtmParameters: eventLabelView,
        gtmAction: fireGtm,
        createGtmObject: _GuestPersonalInfo.createGtmObject,
        errorCallback: errorCallback,
        gtmParams: gtmParams,
        gtmLabel: gtmLabel,
        value: props.values[_constant2.FIELDS.passportNumber.name],
        validate: function validate(val) {
          return (0, _GuestPersonalInfo.validators)(val, language.passportNumber || _constant2.FIELDS.passportNumber.label, language, [_GuestPersonalInfo.validate.required, _GuestPersonalInfo.validate.alphanumericspace, _GuestPersonalInfo.validate.maxLen]);
        },
        touched: props.touched[_constant2.FIELDS.passportNumber.name],
        isRequired: isPassportMandatory,
        disabled: disableDocumentNumber,
        triggerOnChange: true
      })), /*#__PURE__*/_react.default.createElement(_GuestPersonalInfo.FieldWrapper, {
        width: isMobile ? 100 : 50
      }, /*#__PURE__*/_react.default.createElement(_formik.Field, {
        component: _GuestPersonalInfo.renderDate,
        accessible: accessible,
        alwaysShowLabel: false // label={language.expiryDate || FIELDS.expiryDate.label}
        ,
        label: // eslint-disable-next-line max-len
        (isPassportMandatory || isExpiryDateMandatory ? String(language.expiryDate).split('(')[0].trim() : language.expiryDate) || _constant2.FIELDS.expiryDate.label,
        name: _constant2.FIELDS.expiryDate.name,
        theme: theme,
        handleField: handleField,
        gtmParameters: eventLabelView,
        gtmAction: fireGtm,
        createGtmObject: _GuestPersonalInfo.createGtmObject,
        errorCallback: errorCallback,
        gtmParams: gtmParams,
        gtmLabel: gtmLabel,
        value: props.values[_constant2.FIELDS.expiryDate.name],
        validate: function validate(val) {
          return _GuestPersonalInfo.validate.date(val, language.expiryDate || _constant2.FIELDS.expiryDate.label, language, isMobile, '', flightDate, false, {}, true, (isPassportMandatory || isExpiryDateMandatory) && props.values[_constant2.FIELDS.type.name] === _constant2.DEFAULT_DOC_TYPE.value, false);
        },
        isMobile: isMobile && !isWMP // isRequired={props.values[FIELDS.expiryDate.name] !== ''}
        ,
        isRequired: isPassportMandatory || props.values[_constant2.FIELDS.expiryDate.name] !== '',
        placeholder: language.dateFormat,
        touched: props.touched[_constant2.FIELDS.expiryDate.name],
        disabled: disableExpiryDate,
        triggerOnChange: true
      })))))
    );
  })));
};

GuestPassportInfo.propTypes = _GuestPassportInfo.default.PropTypes;
GuestPassportInfo.defaultProps = _GuestPassportInfo.default.DefaultProps;
var _default = GuestPassportInfo;
exports.default = _default;